import { siteLocales } from './translations.locales';

export const translations = {
  'pt-BR': {
    // Header
    nav: {
      about: 'Sobre',
      services: 'Serviços',
      methodology: 'Metodologia',
      founder: 'Fundador',
      contact: 'Contato'
    },
    
    // Hero
    hero: {
      title: 'Transforme Seu Negócio com',
      titleHighlight: 'Soluções Digitais Premium',
      subtitle: 'Desenvolvimento web profissional, marketing digital estratégico e automação inteligente para empresas que buscam excelência e resultados reais.',
      cta: 'Agendar demonstração',
      ctaSecondary: 'Falar no WhatsApp'
    },
    
    // About
    about: {
      title: 'Sobre a WSJ Soluções Digitais',
      description:
        'Tudo começou com a visão de William Sarti José de transformar ideias em soluções digitais modernas, elegantes e orientadas para resultados reais.',
      description2:
        'A WSJ. Soluções Digitais desenvolve plataformas web, automações, e-commerce, sistemas personalizados, cardápios digitais inteligentes e soluções escaláveis para empresas que desejam crescer no ambiente digital.\n\nO ponto em "WSJ." representa continuidade, evolução e expansão constante — uma marca preparada para transformar negócios através da tecnologia.',
      yearsTitle: 'Anos de Experiência',
      clientsTitle: 'Clientes Satisfeitos',
      projectsTitle: 'Projetos Entregues'
    },
    
    // Success Pyramid
    pyramid: {
      title: 'Nossa Metodologia: Pirâmide do Sucesso Digital',
      subtitle: 'Uma abordagem estruturada e comprovada para transformar sua presença digital em resultados concretos',
      
      level1Title: 'Site Próprio',
      level1Subtitle: 'Fundação Profissional',
      level1Point1: 'Sites institucionais premium com design moderno',
      level1Point2: 'Landing pages de alta conversão',
      level1Point3: 'Integrações e automação avançada',
      level1Point4: 'Experiência do usuário otimizada',
      
      level2Title: 'Marketing Digital',
      level2Subtitle: 'Crescimento Estratégico',
      level2Point1: 'Gestão profissional de redes sociais',
      level2Point2: 'Produção de vídeos e conteúdo visual',
      level2Point3: 'Campanhas de anúncios orientadas a ROI',
      level2Point4: 'Análise de dados e otimização contínua',
      
      level3Title: 'Serviços de TI',
      level3Subtitle: 'Inovação e Escalabilidade',
      level3Point1: 'Desenvolvimento web e aplicativos mobile',
      level3Point2: 'E-commerce completo e integrações',
      level3Point3: 'Automação de processos e sistemas',
      level3Point4: 'Soluções personalizadas e escaláveis'
    },
    
    // Services
    services: {
      title: 'Nossos Serviços',
      subtitle: 'Soluções completas para transformar seu negócio digitalmente',
      
      service1Title: 'Desenvolvimento Web',
      service1Desc: 'Sites institucionais, landing pages e portais profissionais com design premium e tecnologia de ponta.',
      
      service2Title: 'E-commerce',
      service2Desc: 'Lojas virtuais completas, integrações de pagamento e gestão automatizada para maximizar suas vendas online.',
      
      service3Title: 'Marketing Digital',
      service3Desc: 'Estratégias integradas de marketing, gestão de redes sociais e campanhas publicitárias com foco em resultados.',
      
      service4Title: 'Automação',
      service4Desc: 'Otimize processos, economize tempo e reduza custos com automação inteligente e integrações personalizadas.',
      
      service5Title: 'Aplicativos Mobile',
      service5Desc: 'Apps nativos e híbridos para iOS e Android, com design intuitivo e performance excepcional.',
      
      service6Title: 'Consultoria em TI',
      service6Desc: 'Assessoria especializada para transformação digital, arquitetura de sistemas e estratégias tecnológicas.',
      
      service7Title: 'Cardápio Digital',
      service7Desc:
        'Cardápios digitais para restaurantes, confeitarias, barbearias, salões e serviços por agendamento, com pedidos online, WhatsApp, QR Code, horários e pacotes.',
      
      service8Title: 'Transporte Urbano em Tempo Real',
      service8Desc:
        'Soluções inteligentes para monitoramento e visualização de transporte urbano em tempo real, com foco em mobilidade, localização e experiência do utilizador.',
      
      cta: 'Conhecer Todos os Serviços'
    },
    
    // Founder
    founder: {
      title: 'Conheça o Fundador',
      name: 'William Sarti José',
      role: 'Fundador & Software Engineer',
      bio: 'Com mais de 10 anos de experiência em Tecnologia da Informação, William é especialista em Java, React e Inteligência Artificial. Sua trajetória inclui atuação como professor de informática, desenvolvedor sênior e líder de projetos tecnológicos complexos.',
      bio2: 'Formado e com sólida experiência acadêmica e profissional, William combina conhecimento técnico aprofundado com visão estratégica de negócios, entregando soluções que realmente fazem a diferença para os clientes.',
      
      expertiseTitle: 'Áreas de Expertise',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & Desenvolvimento Frontend',
      expertise3: 'Inteligência Artificial & Machine Learning',
      expertise4: 'Arquitetura de Sistemas',
      expertise5: 'Gestão de Projetos',
      expertise6: 'Ensino e Mentoria',
      
      authorityTitle: 'Autoridade Profissional',
      linkedin: 'LinkedIn Profissional',
      lattes: 'Currículo Lattes',
      github: 'Repositório no GitHub',
      professionalCourse: 'Curso Profissional',
      location: 'Braga, Portugal'
    },
    
    // Contact
    contact: {
      title: 'Vamos Transformar Seu Negócio?',
      subtitle: 'Entre em contato e descubra como podemos ajudar sua empresa a alcançar novos patamares',
      
      formTitle: 'Envie Sua Mensagem',
      nameLabel: 'Seu Nome',
      namePlaceholder: 'Digite seu nome completo',
      emailLabel: 'Seu E-mail',
      emailPlaceholder: 'seu@email.com',
      phoneLabel: 'Telefone (opcional)',
      phonePlaceholder: '+55 (00) 00000-0000',
      messageLabel: 'Mensagem',
      messagePlaceholder: 'Conte-nos sobre seu projeto...',
      submitButton: 'Enviar Mensagem',
      
      whatsappTitle: 'Ou Fale Direto no WhatsApp',
      whatsappButton: 'Abrir WhatsApp',
      
      infoTitle: 'Informações de Contato',
      phone: 'Telefone',
      email: 'E-mail',
      locationLabel: 'Localização',
      phonesTitle: 'Telefones',
      locationsTitle: 'Localizações',
      phoneBrazilLabel: 'Brasil',
      phonePortugalLabel: 'Portugal',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'São Paulo, Brasil',
      locationPortugal: 'Braga, Portugal'
    },
    
    // Footer
    footer: {
      tagline: 'Transformando ideias em soluções digitais de excelência',
      servicesTitle: 'Serviços',
      companyTitle: 'Empresa',
      contactTitle: 'Contato',
      
      servicesList: {
        web: 'Desenvolvimento Web',
        ecommerce: 'E-commerce',
        marketing: 'Marketing Digital',
        automation: 'Automação',
        mobile: 'Apps Mobile'
      },
      
      companyList: {
        about: 'Sobre Nós',
        methodology: 'Metodologia',
        founder: 'Fundador',
        contact: 'Contato'
      },
      
      copyright: '© 2025 WSJ Soluções Digitais. Todos os direitos reservados.',
      followTitle: 'Siga a WSJ',
      madeWith: 'Feito com',
      location: 'em Braga, Portugal'
    }
  },
  
  'pt-PT': {
    // Header
    nav: {
      about: 'Sobre',
      services: 'Serviços',
      methodology: 'Metodologia',
      founder: 'Fundador',
      contact: 'Contacto'
    },
    
    // Hero
    hero: {
      title: 'Transforme o Seu Negócio com',
      titleHighlight: 'Soluções Digitais Premium',
      subtitle: 'Desenvolvimento web profissional, marketing digital estratégico e automação inteligente para empresas que procuram excelência e resultados reais.',
      cta: 'Agendar demonstração',
      ctaSecondary: 'Falar no WhatsApp'
    },
    
    // About
    about: {
      title: 'Sobre a WSJ Soluções Digitais',
      description:
        'Tudo começou com a visão de William Sarti José de transformar ideias em soluções digitais modernas, elegantes e orientadas para resultados reais.',
      description2:
        'A WSJ. Soluções Digitais desenvolve plataformas web, automações, e-commerce, sistemas personalizados, cardápios digitais inteligentes e soluções escaláveis para empresas que desejam crescer no ambiente digital.\n\nO ponto em "WSJ." representa continuidade, evolução e expansão constante — uma marca preparada para transformar negócios através da tecnologia.',
      yearsTitle: 'Anos de Experiência',
      clientsTitle: 'Clientes Satisfeitos',
      projectsTitle: 'Projetos Entregues'
    },
    
    // Success Pyramid
    pyramid: {
      title: 'Nossa Metodologia: Pirâmide do Sucesso Digital',
      subtitle: 'Uma abordagem estruturada e comprovada para transformar a sua presença digital em resultados concretos',
      
      level1Title: 'Site Próprio',
      level1Subtitle: 'Fundação Profissional',
      level1Point1: 'Sites institucionais premium com design moderno',
      level1Point2: 'Landing pages de alta conversão',
      level1Point3: 'Integrações e automação avançada',
      level1Point4: 'Experiência do utilizador otimizada',
      
      level2Title: 'Marketing Digital',
      level2Subtitle: 'Crescimento Estratégico',
      level2Point1: 'Gestão profissional de redes sociais',
      level2Point2: 'Produção de vídeos e conteúdo visual',
      level2Point3: 'Campanhas de anúncios orientadas a ROI',
      level2Point4: 'Análise de dados e otimização contínua',
      
      level3Title: 'Serviços de TI',
      level3Subtitle: 'Inovação e Escalabilidade',
      level3Point1: 'Desenvolvimento web e aplicações móveis',
      level3Point2: 'E-commerce completo e integrações',
      level3Point3: 'Automação de processos e sistemas',
      level3Point4: 'Soluções personalizadas e escaláveis'
    },
    
    // Services
    services: {
      title: 'Nossos Serviços',
      subtitle: 'Soluções completas para transformar o seu negócio digitalmente',
      
      service1Title: 'Desenvolvimento Web',
      service1Desc: 'Sites institucionais, landing pages e portais profissionais com design premium e tecnologia de ponta.',
      
      service2Title: 'E-commerce',
      service2Desc: 'Lojas virtuais completas, integrações de pagamento e gestão automatizada para maximizar as suas vendas online.',
      
      service3Title: 'Marketing Digital',
      service3Desc: 'Estratégias integradas de marketing, gestão de redes sociais e campanhas publicitárias com foco em resultados.',
      
      service4Title: 'Automação',
      service4Desc: 'Otimize processos, economize tempo e reduza custos com automação inteligente e integrações personalizadas.',
      
      service5Title: 'Aplicações Móveis',
      service5Desc: 'Apps nativos e híbridos para iOS e Android, com design intuitivo e desempenho excepcional.',
      
      service6Title: 'Consultoria em TI',
      service6Desc: 'Assessoria especializada para transformação digital, arquitetura de sistemas e estratégias tecnológicas.',
      
      service7Title: 'Cardápio Digital',
      service7Desc:
        'Cardápios digitais para restaurantes, confeitarias, barbearias, salões e serviços por agendamento, com pedidos online, WhatsApp, QR Code, horários e pacotes.',
      
      service8Title: 'Transporte Urbano em Tempo Real',
      service8Desc:
        'Soluções inteligentes para monitoramento e visualização de transporte urbano em tempo real, com foco em mobilidade, localização e experiência do utilizador.',
      
      cta: 'Conhecer Todos os Serviços'
    },
    
    // Founder
    founder: {
      title: 'Conheça o Fundador',
      name: 'William Sarti José',
      role: 'Fundador & Software Engineer',
      bio: 'Com mais de 10 anos de experiência em Tecnologia da Informação, William é especialista em Java, React e Inteligência Artificial. A sua trajetória inclui atuação como professor de informática, programador sénior e líder de projetos tecnológicos complexos.',
      bio2: 'Formado e com sólida experiência académica e profissional, William combina conhecimento técnico aprofundado com visão estratégica de negócios, entregando soluções que realmente fazem a diferença para os clientes.',
      
      expertiseTitle: 'Áreas de Expertise',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & Desenvolvimento Frontend',
      expertise3: 'Inteligência Artificial & Machine Learning',
      expertise4: 'Arquitetura de Sistemas',
      expertise5: 'Gestão de Projetos',
      expertise6: 'Ensino e Mentoria',
      
      authorityTitle: 'Autoridade Profissional',
      linkedin: 'LinkedIn Profissional',
      lattes: 'Currículo Lattes',
      github: 'Repositório no GitHub',
      professionalCourse: 'Curso Profissional',
      location: 'Braga, Portugal'
    },
    
    // Contact
    contact: {
      title: 'Vamos Transformar o Seu Negócio?',
      subtitle: 'Entre em contacto e descubra como podemos ajudar a sua empresa a alcançar novos patamares',
      
      formTitle: 'Envie a Sua Mensagem',
      nameLabel: 'Seu Nome',
      namePlaceholder: 'Digite o seu nome completo',
      emailLabel: 'Seu E-mail',
      emailPlaceholder: 'seu@email.com',
      phoneLabel: 'Telefone (opcional)',
      phonePlaceholder: '+351 000 000 000',
      messageLabel: 'Mensagem',
      messagePlaceholder: 'Conte-nos sobre o seu projeto...',
      submitButton: 'Enviar Mensagem',
      
      whatsappTitle: 'Ou Fale Direto no WhatsApp',
      whatsappButton: 'Abrir WhatsApp',
      
      infoTitle: 'Informações de Contacto',
      phone: 'Telefone',
      email: 'E-mail',
      locationLabel: 'Localização',
      phonesTitle: 'Telefones',
      locationsTitle: 'Localizações',
      phoneBrazilLabel: 'Brasil',
      phonePortugalLabel: 'Portugal',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'São Paulo, Brasil',
      locationPortugal: 'Braga, Portugal'
    },
    
    // Footer
    footer: {
      tagline: 'Transformando ideias em soluções digitais de excelência',
      servicesTitle: 'Serviços',
      companyTitle: 'Empresa',
      contactTitle: 'Contacto',
      
      servicesList: {
        web: 'Desenvolvimento Web',
        ecommerce: 'E-commerce',
        marketing: 'Marketing Digital',
        automation: 'Automação',
        mobile: 'Apps Móveis'
      },
      
      companyList: {
        about: 'Sobre Nós',
        methodology: 'Metodologia',
        founder: 'Fundador',
        contact: 'Contacto'
      },
      
      copyright: '© 2025 WSJ Soluções Digitais. Todos os direitos reservados.',
      followTitle: 'Siga a WSJ',
      madeWith: 'Feito com',
      location: 'em Braga, Portugal'
    }
  },
  
  'en': {
    // Header
    nav: {
      about: 'About',
      services: 'Services',
      methodology: 'Methodology',
      founder: 'Founder',
      contact: 'Contact'
    },
    
    // Hero
    hero: {
      title: 'Transform Your Business with',
      titleHighlight: 'Premium Digital Solutions',
      subtitle: 'Professional web development, strategic digital marketing, and intelligent automation for companies seeking excellence and real results.',
      cta: 'Schedule a demo',
      ctaSecondary: 'Chat on WhatsApp'
    },
    
    // About
    about: {
      title: 'About WSJ Digital Solutions',
      description:
        'It began with William Sarti José’s vision to turn ideas into modern, elegant digital solutions built for real outcomes.',
      description2:
        'WSJ Digital Solutions builds web platforms, automation, e-commerce, bespoke systems, smart digital menus, and scalable products for companies growing in the digital space.\n\nThe dot in “WSJ.” stands for continuity, evolution, and constant expansion — a brand ready to transform businesses through technology.',
      yearsTitle: 'Years of Experience',
      clientsTitle: 'Satisfied Clients',
      projectsTitle: 'Delivered Projects'
    },
    
    // Success Pyramid
    pyramid: {
      title: 'Our Methodology: Digital Success Pyramid',
      subtitle: 'A structured and proven approach to transform your digital presence into concrete results',
      
      level1Title: 'Own Website',
      level1Subtitle: 'Professional Foundation',
      level1Point1: 'Premium institutional websites with modern design',
      level1Point2: 'High-conversion landing pages',
      level1Point3: 'Advanced integrations and automation',
      level1Point4: 'Optimized user experience',
      
      level2Title: 'Digital Marketing',
      level2Subtitle: 'Strategic Growth',
      level2Point1: 'Professional social media management',
      level2Point2: 'Video production and visual content',
      level2Point3: 'ROI-oriented advertising campaigns',
      level2Point4: 'Data analysis and continuous optimization',
      
      level3Title: 'IT Services',
      level3Subtitle: 'Innovation and Scalability',
      level3Point1: 'Web and mobile app development',
      level3Point2: 'Complete e-commerce and integrations',
      level3Point3: 'Process and system automation',
      level3Point4: 'Customized and scalable solutions'
    },
    
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'Complete solutions to digitally transform your business',
      
      service1Title: 'Web Development',
      service1Desc: 'Institutional websites, landing pages, and professional portals with premium design and cutting-edge technology.',
      
      service2Title: 'E-commerce',
      service2Desc: 'Complete online stores, payment integrations, and automated management to maximize your online sales.',
      
      service3Title: 'Digital Marketing',
      service3Desc: 'Integrated marketing strategies, social media management, and advertising campaigns focused on results.',
      
      service4Title: 'Automation',
      service4Desc: 'Optimize processes, save time, and reduce costs with intelligent automation and customized integrations.',
      
      service5Title: 'Mobile Apps',
      service5Desc: 'Native and hybrid apps for iOS and Android, with intuitive design and exceptional performance.',
      
      service6Title: 'IT Consulting',
      service6Desc: 'Specialized advisory for digital transformation, system architecture, and technological strategies.',
      
      service7Title: 'Digital menu',
      service7Desc:
        'Digital menus for restaurants, bakeries, barbershops, salons, and appointment-based businesses, with online orders, WhatsApp, QR codes, schedules, and packages.',
      
      service8Title: 'Real-time urban transport',
      service8Desc:
        'Smart solutions for monitoring and visualizing urban transport in real time, with a focus on mobility, location, and user experience.',
      
      cta: 'Explore All Services'
    },
    
    // Founder
    founder: {
      title: 'Meet the Founder',
      name: 'William Sarti José',
      role: 'Founder & Software Engineer',
      bio: 'With over 10 years of experience in Information Technology, William is a specialist in Java, React, and Artificial Intelligence. His career includes work as a computer science teacher, senior developer, and leader of complex technological projects.',
      bio2: 'Graduated with solid academic and professional experience, William combines in-depth technical knowledge with strategic business vision, delivering solutions that truly make a difference for clients.',
      
      expertiseTitle: 'Areas of Expertise',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & Frontend Development',
      expertise3: 'Artificial Intelligence & Machine Learning',
      expertise4: 'System Architecture',
      expertise5: 'Project Management',
      expertise6: 'Teaching and Mentoring',
      
      authorityTitle: 'Professional Authority',
      linkedin: 'Professional LinkedIn',
      lattes: 'Lattes CV',
      github: 'GitHub repository',
      professionalCourse: 'Professional course',
      location: 'Braga, Portugal'
    },
    
    // Contact
    contact: {
      title: 'Let\'s Transform Your Business?',
      subtitle: 'Get in touch and discover how we can help your company reach new heights',
      
      formTitle: 'Send Your Message',
      nameLabel: 'Your Name',
      namePlaceholder: 'Enter your full name',
      emailLabel: 'Your Email',
      emailPlaceholder: 'your@email.com',
      phoneLabel: 'Phone (optional)',
      phonePlaceholder: '+55 (00) 00000-0000',
      messageLabel: 'Message',
      messagePlaceholder: 'Tell us about your project...',
      submitButton: 'Send Message',
      
      whatsappTitle: 'Or Chat Directly on WhatsApp',
      whatsappButton: 'Open WhatsApp',
      
      infoTitle: 'Contact Information',
      phone: 'Phone',
      email: 'Email',
      locationLabel: 'Location',
      phonesTitle: 'Phone lines',
      locationsTitle: 'Locations',
      phoneBrazilLabel: 'Brazil',
      phonePortugalLabel: 'Portugal',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'São Paulo, Brazil',
      locationPortugal: 'Braga, Portugal'
    },
    
    // Footer
    footer: {
      tagline: 'Transforming ideas into excellent digital solutions',
      servicesTitle: 'Services',
      companyTitle: 'Company',
      contactTitle: 'Contact',
      
      servicesList: {
        web: 'Web Development',
        ecommerce: 'E-commerce',
        marketing: 'Digital Marketing',
        automation: 'Automation',
        mobile: 'Mobile Apps'
      },
      
      companyList: {
        about: 'About Us',
        methodology: 'Methodology',
        founder: 'Founder',
        contact: 'Contact'
      },
      
      copyright: '© 2025 WSJ Digital Solutions. All rights reserved.',
      followTitle: 'Follow WSJ',
      madeWith: 'Made with',
      location: 'in Braga, Portugal'
    }
  },
  
  'es': {
    // Header
    nav: {
      about: 'Acerca de',
      services: 'Servicios',
      methodology: 'Metodología',
      founder: 'Fundador',
      contact: 'Contacto'
    },
    
    // Hero
    hero: {
      title: 'Transforme Su Negocio con',
      titleHighlight: 'Soluciones Digitales Premium',
      subtitle: 'Desarrollo web profesional, marketing digital estratégico y automatización inteligente para empresas que buscan excelencia y resultados reales.',
      cta: 'Agendar demostración',
      ctaSecondary: 'Hablar en WhatsApp'
    },
    
    // About
    about: {
      title: 'Acerca de WSJ Soluciones Digitales',
      description:
        'Todo comenzó con la visión de William Sarti José: transformar ideas en soluciones digitales modernas, elegantes y orientadas a resultados reales.',
      description2:
        'WSJ Soluciones Digitales desarrolla plataformas web, automatización, e-commerce, sistemas a medida, cartas digitales inteligentes y soluciones escalables para empresas que quieren crecer en el entorno digital.\n\nEl punto en “WSJ.” simboliza continuidad, evolución y expansión constante: una marca preparada para transformar negocios con tecnología.',
      yearsTitle: 'Años de Experiencia',
      clientsTitle: 'Clientes Satisfechos',
      projectsTitle: 'Proyectos Entregados'
    },
    
    // Success Pyramid
    pyramid: {
      title: 'Nuestra Metodología: Pirámide del Éxito Digital',
      subtitle: 'Un enfoque estructurado y probado para transformar su presencia digital en resultados concretos',
      
      level1Title: 'Sitio Propio',
      level1Subtitle: 'Fundación Profesional',
      level1Point1: 'Sitios institucionales premium con diseño moderno',
      level1Point2: 'Landing pages de alta conversión',
      level1Point3: 'Integraciones y automatización avanzada',
      level1Point4: 'Experiencia del usuario optimizada',
      
      level2Title: 'Marketing Digital',
      level2Subtitle: 'Crecimiento Estratégico',
      level2Point1: 'Gestión profesional de redes sociales',
      level2Point2: 'Producción de videos y contenido visual',
      level2Point3: 'Campañas de anuncios orientadas a ROI',
      level2Point4: 'Análisis de datos y optimización continua',
      
      level3Title: 'Servicios de TI',
      level3Subtitle: 'Innovación y Escalabilidad',
      level3Point1: 'Desarrollo web y aplicaciones móviles',
      level3Point2: 'E-commerce completo e integraciones',
      level3Point3: 'Automatización de procesos y sistemas',
      level3Point4: 'Soluciones personalizadas y escalables'
    },
    
    // Services
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones completas para transformar su negocio digitalmente',
      
      service1Title: 'Desarrollo Web',
      service1Desc: 'Sitios institucionales, landing pages y portales profesionales con diseño premium y tecnología de punta.',
      
      service2Title: 'E-commerce',
      service2Desc: 'Tiendas virtuales completas, integraciones de pago y gestión automatizada para maximizar sus ventas online.',
      
      service3Title: 'Marketing Digital',
      service3Desc: 'Estrategias integradas de marketing, gestión de redes sociales y campañas publicitarias enfocadas en resultados.',
      
      service4Title: 'Automatización',
      service4Desc: 'Optimice procesos, ahorre tiempo y reduzca costos con automatización inteligente e integraciones personalizadas.',
      
      service5Title: 'Apps Móviles',
      service5Desc: 'Apps nativos e híbridos para iOS y Android, con diseño intuitivo y rendimiento excepcional.',
      
      service6Title: 'Consultoría en TI',
      service6Desc: 'Asesoría especializada para transformación digital, arquitectura de sistemas y estrategias tecnológicas.',
      
      service7Title: 'Menú digital',
      service7Desc:
        'Menús digitales para restaurantes, pastelerías, barberías, salones y negocios con cita previa, con pedidos online, WhatsApp, código QR, horarios y paquetes.',
      
      service8Title: 'Transporte urbano en tiempo real',
      service8Desc:
        'Soluciones inteligentes para el seguimiento y la visualización del transporte urbano en tiempo real, con foco en movilidad, ubicación y experiencia del usuario.',
      
      cta: 'Conocer Todos los Servicios'
    },
    
    // Founder
    founder: {
      title: 'Conozca al Fundador',
      name: 'William Sarti José',
      role: 'Fundador & Software Engineer',
      bio: 'Con más de 10 años de experiencia en Tecnología de la Información, William es especialista en Java, React e Inteligencia Artificial. Su trayectoria incluye actuación como profesor de informática, desarrollador senior y líder de proyectos tecnológicos complejos.',
      bio2: 'Graduado y con sólida experiencia académica y profesional, William combina conocimiento técnico profundo con visión estratégica de negocios, entregando soluciones que realmente hacen la diferencia para los clientes.',
      
      expertiseTitle: 'Áreas de Experiencia',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & Desarrollo Frontend',
      expertise3: 'Inteligencia Artificial & Machine Learning',
      expertise4: 'Arquitectura de Sistemas',
      expertise5: 'Gestión de Proyectos',
      expertise6: 'Enseñanza y Mentoría',
      
      authorityTitle: 'Autoridad Profesional',
      linkedin: 'LinkedIn Profesional',
      lattes: 'Currículum Lattes',
      github: 'Repositorio en GitHub',
      professionalCourse: 'Curso profesional',
      location: 'Braga, Portugal'
    },
    
    // Contact
    contact: {
      title: '¿Vamos a Transformar Su Negocio?',
      subtitle: 'Póngase en contacto y descubra cómo podemos ayudar a su empresa a alcanzar nuevos niveles',
      
      formTitle: 'Envíe Su Mensaje',
      nameLabel: 'Su Nombre',
      namePlaceholder: 'Ingrese su nombre completo',
      emailLabel: 'Su Email',
      emailPlaceholder: 'su@email.com',
      phoneLabel: 'Teléfono (opcional)',
      phonePlaceholder: '+34 000 000 000',
      messageLabel: 'Mensaje',
      messagePlaceholder: 'Cuéntenos sobre su proyecto...',
      submitButton: 'Enviar Mensaje',
      
      whatsappTitle: 'O Hable Directo en WhatsApp',
      whatsappButton: 'Abrir WhatsApp',
      
      infoTitle: 'Información de Contacto',
      phone: 'Teléfono',
      email: 'Email',
      locationLabel: 'Ubicación',
      phonesTitle: 'Teléfonos',
      locationsTitle: 'Ubicaciones',
      phoneBrazilLabel: 'Brasil',
      phonePortugalLabel: 'Portugal',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'São Paulo, Brasil',
      locationPortugal: 'Braga, Portugal'
    },
    
    // Footer
    footer: {
      tagline: 'Transformando ideas en soluciones digitales de excelencia',
      servicesTitle: 'Servicios',
      companyTitle: 'Empresa',
      contactTitle: 'Contacto',
      
      servicesList: {
        web: 'Desarrollo Web',
        ecommerce: 'E-commerce',
        marketing: 'Marketing Digital',
        automation: 'Automatización',
        mobile: 'Apps Móviles'
      },
      
      companyList: {
        about: 'Acerca de',
        methodology: 'Metodología',
        founder: 'Fundador',
        contact: 'Contacto'
      },
      
      copyright: '© 2025 WSJ Soluciones Digitales. Todos los derechos reservados.',
      followTitle: 'Sigue a WSJ',
      madeWith: 'Hecho con',
      location: 'en Braga, Portugal'
    }
  },
  
  'fr': {
    // Header
    nav: {
      about: 'À propos',
      services: 'Services',
      methodology: 'Méthodologie',
      founder: 'Fondateur',
      contact: 'Contact'
    },
    
    // Hero
    hero: {
      title: 'Transformez Votre Entreprise avec',
      titleHighlight: 'Solutions Numériques Premium',
      subtitle: 'Développement web professionnel, marketing digital stratégique et automatisation intelligente pour les entreprises recherchant l\'excellence et des résultats réels.',
      cta: 'Planifier une démonstration',
      ctaSecondary: 'Parler sur WhatsApp'
    },
    
    // About
    about: {
      title: 'À propos de WSJ Solutions Digitales',
      description:
        'Tout a commencé par la vision de William Sarti José : transformer des idées en solutions digitales modernes, élégantes et tournées vers des résultats concrets.',
      description2:
        'WSJ Solutions Digitales conçoit des plateformes web, de l’automatisation, du e-commerce, des systèmes sur mesure, des menus numériques intelligents et des solutions scalables pour les entreprises qui veulent croître en ligne.\n\nLe point dans « WSJ. » incarne continuité, évolution et expansion — une marque prête à transformer les business grâce à la technologie.',
      yearsTitle: 'Années d\'Expérience',
      clientsTitle: 'Clients Satisfaits',
      projectsTitle: 'Projets Livrés'
    },
    
    // Success Pyramid
    pyramid: {
      title: 'Notre Méthodologie : Pyramide du Succès Digital',
      subtitle: 'Une approche structurée et éprouvée pour transformer votre présence digitale en résultats concrets',
      
      level1Title: 'Site Web Propre',
      level1Subtitle: 'Fondation Professionnelle',
      level1Point1: 'Sites institutionnels premium avec design moderne',
      level1Point2: 'Pages de destination à haute conversion',
      level1Point3: 'Intégrations et automatisation avancées',
      level1Point4: 'Expérience utilisateur optimisée',
      
      level2Title: 'Marketing Digital',
      level2Subtitle: 'Croissance Stratégique',
      level2Point1: 'Gestion professionnelle des réseaux sociaux',
      level2Point2: 'Production de vidéos et contenu visuel',
      level2Point3: 'Campagnes publicitaires orientées ROI',
      level2Point4: 'Analyse de données et optimisation continue',
      
      level3Title: 'Services IT',
      level3Subtitle: 'Innovation et Évolutivité',
      level3Point1: 'Développement web et applications mobiles',
      level3Point2: 'E-commerce complet et intégrations',
      level3Point3: 'Automatisation des processus et systèmes',
      level3Point4: 'Solutions personnalisées et évolutives'
    },
    
    // Services
    services: {
      title: 'Nos Services',
      subtitle: 'Solutions complètes pour transformer votre entreprise numériquement',
      
      service1Title: 'Développement Web',
      service1Desc: 'Sites institutionnels, pages de destination et portails professionnels avec design premium et technologie de pointe.',
      
      service2Title: 'E-commerce',
      service2Desc: 'Boutiques en ligne complètes, intégrations de paiement et gestion automatisée pour maximiser vos ventes en ligne.',
      
      service3Title: 'Marketing Digital',
      service3Desc: 'Stratégies marketing intégrées, gestion des réseaux sociaux et campagnes publicitaires axées sur les résultats.',
      
      service4Title: 'Automatisation',
      service4Desc: 'Optimisez les processus, économisez du temps et réduisez les coûts avec automatisation intelligente et intégrations personnalisées.',
      
      service5Title: 'Apps Mobiles',
      service5Desc: 'Applications natives et hybrides pour iOS et Android, avec design intuitif et performance exceptionnelle.',
      
      service6Title: 'Conseil IT',
      service6Desc: 'Conseil spécialisé pour transformation digitale, architecture de systèmes et stratégies technologiques.',
      
      service7Title: 'Menu numérique',
      service7Desc:
        'Menus numériques pour restaurants, pâtisseries, salons de coiffure, instituts de beauté et services sur rendez-vous, avec commandes en ligne, WhatsApp, QR code, horaires et forfaits.',
      
      service8Title: 'Transport urbain en temps réel',
      service8Desc:
        'Solutions intelligentes pour le suivi et la visualisation du transport urbain en temps réel, avec un accent sur la mobilité, la géolocalisation et l’expérience utilisateur.',
      
      cta: 'Découvrir Tous les Services'
    },
    
    // Founder
    founder: {
      title: 'Rencontrez le Fondateur',
      name: 'William Sarti José',
      role: 'Fondateur & Ingénieur Logiciel',
      bio: 'Avec plus de 10 ans d\'expérience en Technologie de l\'Information, William est spécialiste en Java, React et Intelligence Artificielle. Sa carrière comprend un travail en tant que professeur d\'informatique, développeur senior et leader de projets technologiques complexes.',
      bio2: 'Diplômé avec une solide expérience académique et professionnelle, William combine une connaissance technique approfondie avec une vision stratégique des affaires, livrant des solutions qui font vraiment la différence pour les clients.',
      
      expertiseTitle: 'Domaines d\'Expertise',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & Développement Frontend',
      expertise3: 'Intelligence Artificielle & Machine Learning',
      expertise4: 'Architecture de Systèmes',
      expertise5: 'Gestion de Projets',
      expertise6: 'Enseignement et Mentorat',
      
      authorityTitle: 'Autorité Professionnelle',
      linkedin: 'LinkedIn Professionnel',
      lattes: 'CV Lattes',
      github: 'Dépôt GitHub',
      professionalCourse: 'Cours professionnel',
      location: 'Braga, Portugal'
    },
    
    // Contact
    contact: {
      title: 'Transformons Votre Entreprise ?',
      subtitle: 'Contactez-nous et découvrez comment nous pouvons aider votre entreprise à atteindre de nouveaux sommets',
      
      formTitle: 'Envoyez Votre Message',
      nameLabel: 'Votre Nom',
      namePlaceholder: 'Entrez votre nom complet',
      emailLabel: 'Votre Email',
      emailPlaceholder: 'votre@email.com',
      phoneLabel: 'Téléphone (optionnel)',
      phonePlaceholder: '+33 0 00 00 00 00',
      messageLabel: 'Message',
      messagePlaceholder: 'Parlez-nous de votre projet...',
      submitButton: 'Envoyer le Message',
      
      whatsappTitle: 'Ou Parlez Directement sur WhatsApp',
      whatsappButton: 'Ouvrir WhatsApp',
      
      infoTitle: 'Informations de Contact',
      phone: 'Téléphone',
      email: 'Email',
      locationLabel: 'Localisation',
      phonesTitle: 'Téléphones',
      locationsTitle: 'Localisations',
      phoneBrazilLabel: 'Brésil',
      phonePortugalLabel: 'Portugal',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'São Paulo, Brésil',
      locationPortugal: 'Braga, Portugal'
    },
    
    // Footer
    footer: {
      tagline: 'Transformer des idées en solutions digitales d\'excellence',
      servicesTitle: 'Services',
      companyTitle: 'Entreprise',
      contactTitle: 'Contact',
      
      servicesList: {
        web: 'Développement Web',
        ecommerce: 'E-commerce',
        marketing: 'Marketing Digital',
        automation: 'Automatisation',
        mobile: 'Apps Mobiles'
      },
      
      companyList: {
        about: 'À propos',
        methodology: 'Méthodologie',
        founder: 'Fondateur',
        contact: 'Contact'
      },
      
      copyright: '© 2025 WSJ Solutions Digitales. Tous droits réservés.',
      followTitle: 'Suivez WSJ',
      madeWith: 'Fait avec',
      location: 'à Braga, Portugal'
    }
  },
  
  'it': {
    // Header
    nav: {
      about: 'Chi Siamo',
      services: 'Servizi',
      methodology: 'Metodologia',
      founder: 'Fondatore',
      contact: 'Contatto'
    },
    
    // Hero
    hero: {
      title: 'Trasforma il Tuo Business con',
      titleHighlight: 'Soluzioni Digitali Premium',
      subtitle: 'Sviluppo web professionale, marketing digitale strategico e automazione intelligente per aziende che cercano eccellenza e risultati reali.',
      cta: 'Prenota una dimostrazione',
      ctaSecondary: 'Parla su WhatsApp'
    },
    
    // About
    about: {
      title: 'Chi è WSJ Soluzioni Digitali',
      description:
        'È iniziato tutto dalla visione di William Sarti José: trasformare idee in soluzioni digitali moderne, eleganti e orientate a risultati concreti.',
      description2:
        'WSJ Soluzioni Digitali sviluppa piattaforme web, automazioni, e-commerce, sistemi su misura, menu digitali intelligenti e soluzioni scalabili per aziende che vogliono crescere nel digitale.\n\nIl punto in “WSJ.” rappresenta continuità, evoluzione e espansione costante — un marchio pronto a trasformare i business attraverso la tecnologia.',
      yearsTitle: 'Anni di Esperienza',
      clientsTitle: 'Clienti Soddisfatti',
      projectsTitle: 'Progetti Consegnati'
    },
    
    // Success Pyramid
    pyramid: {
      title: 'La Nostra Metodologia: Piramide del Successo Digitale',
      subtitle: 'Un approccio strutturato e provato per trasformare la tua presenza digitale in risultati concreti',
      
      level1Title: 'Sito Proprio',
      level1Subtitle: 'Fondazione Professionale',
      level1Point1: 'Siti istituzionali premium con design moderno',
      level1Point2: 'Landing page ad alta conversione',
      level1Point3: 'Integrazioni e automazione avanzata',
      level1Point4: 'Esperienza utente ottimizzata',
      
      level2Title: 'Marketing Digitale',
      level2Subtitle: 'Crescita Strategica',
      level2Point1: 'Gestione professionale dei social media',
      level2Point2: 'Produzione di video e contenuti visivi',
      level2Point3: 'Campagne pubblicitarie orientate al ROI',
      level2Point4: 'Analisi dei dati e ottimizzazione continua',
      
      level3Title: 'Servizi IT',
      level3Subtitle: 'Innovazione e Scalabilità',
      level3Point1: 'Sviluppo web e app mobili',
      level3Point2: 'E-commerce completo e integrazioni',
      level3Point3: 'Automazione di processi e sistemi',
      level3Point4: 'Soluzioni personalizzate e scalabili'
    },
    
    // Services
    services: {
      title: 'I Nostri Servizi',
      subtitle: 'Soluzioni complete per trasformare digitalmente il tuo business',
      
      service1Title: 'Sviluppo Web',
      service1Desc: 'Siti istituzionali, landing page e portali professionali con design premium e tecnologia all\'avanguardia.',
      
      service2Title: 'E-commerce',
      service2Desc: 'Negozi online completi, integrazioni di pagamento e gestione automatizzata per massimizzare le tue vendite online.',
      
      service3Title: 'Marketing Digitale',
      service3Desc: 'Strategie di marketing integrate, gestione dei social media e campagne pubblicitarie focalizzate sui risultati.',
      
      service4Title: 'Automazione',
      service4Desc: 'Ottimizza i processi, risparmia tempo e riduci i costi con automazione intelligente e integrazioni personalizzate.',
      
      service5Title: 'App Mobili',
      service5Desc: 'App native e ibride per iOS e Android, con design intuitivo e prestazioni eccezionali.',
      
      service6Title: 'Consulenza IT',
      service6Desc: 'Consulenza specializzata per trasformazione digitale, architettura di sistemi e strategie tecnologiche.',
      
      service7Title: 'Menu digitale',
      service7Desc:
        'Menu digitali per ristoranti, pasticcerie, barbieri, saloni e attività su appuntamento, con ordini online, WhatsApp, QR code, orari e pacchetti.',
      
      service8Title: 'Trasporto urbano in tempo reale',
      service8Desc:
        'Soluzioni intelligenti per monitoraggio e visualizzazione del trasporto urbano in tempo reale, con focus su mobilità, geolocalizzazione ed esperienza utente.',
      
      cta: 'Scopri Tutti i Servizi'
    },
    
    // Founder
    founder: {
      title: 'Conosci il Fondatore',
      name: 'William Sarti José',
      role: 'Fondatore & Software Engineer',
      bio: 'Con oltre 10 anni di esperienza in Tecnologia dell\'Informazione, William è specialista in Java, React e Intelligenza Artificiale. La sua carriera include lavoro come professore di informatica, sviluppatore senior e leader di progetti tecnologici complessi.',
      bio2: 'Laureato con solida esperienza accademica e professionale, William combina conoscenza tecnica approfondita con visione strategica del business, consegnando soluzioni che fanno davvero la differenza per i clienti.',
      
      expertiseTitle: 'Aree di Competenza',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & Sviluppo Frontend',
      expertise3: 'Intelligenza Artificiale & Machine Learning',
      expertise4: 'Architettura di Sistemi',
      expertise5: 'Gestione Progetti',
      expertise6: 'Insegnamento e Mentoring',
      
      authorityTitle: 'Autorità Professionale',
      linkedin: 'LinkedIn Professionale',
      lattes: 'CV Lattes',
      github: 'Repository GitHub',
      professionalCourse: 'Corso professionale',
      location: 'Braga, Portogallo'
    },
    
    // Contact
    contact: {
      title: 'Trasformiamo il Tuo Business?',
      subtitle: 'Contattaci e scopri come possiamo aiutare la tua azienda a raggiungere nuovi livelli',
      
      formTitle: 'Invia il Tuo Messaggio',
      nameLabel: 'Il Tuo Nome',
      namePlaceholder: 'Inserisci il tuo nome completo',
      emailLabel: 'La Tua Email',
      emailPlaceholder: 'tua@email.com',
      phoneLabel: 'Telefono (opzionale)',
      phonePlaceholder: '+39 000 000 0000',
      messageLabel: 'Messaggio',
      messagePlaceholder: 'Raccontaci del tuo progetto...',
      submitButton: 'Invia Messaggio',
      
      whatsappTitle: 'O Parla Direttamente su WhatsApp',
      whatsappButton: 'Apri WhatsApp',
      
      infoTitle: 'Informazioni di Contatto',
      phone: 'Telefono',
      email: 'Email',
      locationLabel: 'Posizione',
      phonesTitle: 'Telefoni',
      locationsTitle: 'Sedi',
      phoneBrazilLabel: 'Brasile',
      phonePortugalLabel: 'Portogallo',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'San Paolo, Brasile',
      locationPortugal: 'Braga, Portogallo'
    },
    
    // Footer
    footer: {
      tagline: 'Trasformando idee in soluzioni digitali di eccellenza',
      servicesTitle: 'Servizi',
      companyTitle: 'Azienda',
      contactTitle: 'Contatto',
      
      servicesList: {
        web: 'Sviluppo Web',
        ecommerce: 'E-commerce',
        marketing: 'Marketing Digitale',
        automation: 'Automazione',
        mobile: 'App Mobili'
      },
      
      companyList: {
        about: 'Chi Siamo',
        methodology: 'Metodologia',
        founder: 'Fondatore',
        contact: 'Contatto'
      },
      
      copyright: '© 2025 WSJ Soluzioni Digitali. Tutti i diritti riservati.',
      followTitle: 'Segui WSJ',
      madeWith: 'Fatto con',
      location: 'a Braga, Portogallo'
    }
  },
  
  'hi': {
    // Header
    nav: {
      about: 'हमारे बारे में',
      services: 'सेवाएं',
      methodology: 'पद्धति',
      founder: 'संस्थापक',
      contact: 'संपर्क'
    },
    
    // Hero
    hero: {
      title: 'अपने व्यवसाय को बदलें',
      titleHighlight: 'प्रीमियम डिजिटल समाधानों के साथ',
      subtitle: 'पेशेवर वेब विकास, रणनीतिक डिजिटल मार्केटिंग और उत्कृष्टता और वास्तविक परिणाम चाहने वाली कंपनियों के लिए बुद्धिमान स्वचालन।',
      cta: 'डेमो शेड्यूल करें',
      ctaSecondary: 'व्हाट्सएप पर बात करें'
    },
    
    // About
    about: {
      title: 'WSJ डिजिटल सॉल्यूशंस के बारे में',
      description:
        'यह विलियम सार्टी जोस की दृष्टि से शुरू हुआ: विचारों को आधुनिक, सुरुचिपूर्ण और वास्तविक परिणामों पर केंद्रित डिजिटल समाधानों में बदलना।',
      description2:
        'WSJ डिजिटल सॉल्यूशंस वेब प्लेटफ़ॉर्म, ऑटोमेशन, ई-कॉमर्स, कस्टम सिस्टम, स्मार्ट डिजिटल मेनू और स्केलेबल समाधान बनाता है — उन व्यवसायों के लिए जो डिजिटल दुनिया में बढ़ना चाहते हैं।\n\n“WSJ.” में बिंदु निरंतरता, विकास और विस्तार का प्रतीक है — प्रौद्योगिकि से व्यवसायों को बदलने के लिए तैयार एक ब्रांड।',
      yearsTitle: 'वर्षों का अनुभव',
      clientsTitle: 'संतुष्ट ग्राहक',
      projectsTitle: 'वितरित परियोजनाएं'
    },
    
    // Success Pyramid
    pyramid: {
      title: 'हमारी पद्धति: डिजिटल सफलता पिरामिड',
      subtitle: 'आपकी डिजिटल उपस्थिति को ठोस परिणामों में बदलने के लिए एक संरचित और सिद्ध दृष्टिकोण',
      
      level1Title: 'अपनी वेबसाइट',
      level1Subtitle: 'पेशेवर नींव',
      level1Point1: 'आधुनिक डिजाइन के साथ प्रीमियम संस्थागत वेबसाइट',
      level1Point2: 'उच्च रूपांतरण लैंडिंग पृष्ठ',
      level1Point3: 'उन्नत एकीकरण और स्वचालन',
      level1Point4: 'अनुकूलित उपयोगकर्ता अनुभव',
      
      level2Title: 'डिजिटल मार्केटिंग',
      level2Subtitle: 'रणनीतिक विकास',
      level2Point1: 'सोशल मीडिया का पेशेवर प्रबंधन',
      level2Point2: 'वीडियो उत्पादन और दृश्य सामग्री',
      level2Point3: 'ROI-उन्मुख विज्ञापन अभियान',
      level2Point4: 'डेटा विश्लेषण और निरंतर अनुकूलन',
      
      level3Title: 'आईटी सेवाएं',
      level3Subtitle: 'नवाचार और स्केलेबिलिटी',
      level3Point1: 'वेब और मोबाइल ऐप विकास',
      level3Point2: 'पूर्ण ई-कॉमर्स और एकीकरण',
      level3Point3: 'प्रक्रिया और सिस्टम स्वचालन',
      level3Point4: 'अनुकूलित और स्केलेबल समाधान'
    },
    
    // Services
    services: {
      title: 'हमारी सेवाएं',
      subtitle: 'आपके व्यवसाय को डिजिटल रूप से परिवर्तित करने के लिए संपूर्ण समाधान',
      
      service1Title: 'वेब विकास',
      service1Desc: 'प्रीमियम डिजाइन और अत्याधुनिक तकनीक के साथ संस्थागत वेबसाइट, लैंडिंग पृष्ठ और पेशेवर पोर्टल।',
      
      service2Title: 'ई-कॉमर्स',
      service2Desc: 'आपकी ऑनलाइन बिक्री को अधिकतम करने के लिए पूर्ण ऑनलाइन स्टोर, भुगतान एकीकरण और स्वचालित प्रबंधन।',
      
      service3Title: 'डिजिटल मार्केटिंग',
      service3Desc: 'एकीकृत मार्केटिंग रणनीतियां, सोशल मीडिया प्रबंधन और परिणाम-केंद्रित विज्ञापन अभियान।',
      
      service4Title: 'स्वचालन',
      service4Desc: 'बुद्धिमान स्वचालन और अनुकूलित एकीकरण के साथ प्रक्रियाओं को अनुकूलित करें, समय बचाएं और लागत कम करें।',
      
      service5Title: 'मोबाइल ऐप्स',
      service5Desc: 'iOS और Android के लिए सहज डिजाइन और असाधारण प्रदर्शन के साथ देशी और हाइब्रिड ऐप्स।',
      
      service6Title: 'आईटी परामर्श',
      service6Desc: 'डिजिटल परिवर्तन, सिस्टम आर्किटेक्चर और तकनीकी रणनीतियों के लिए विशेष सलाह।',
      
      service7Title: 'डिजिटल मेनू',
      service7Desc:
        'रेस्तरां, बेकरी, नाई, सैलून और अपॉइंटमेंट वाले व्यवसायों के लिए डिजिटल मेनू: ऑनलाइन ऑर्डर, WhatsApp, QR, समय स्लॉट और पैकेज।',
      
      service8Title: 'रीयल-टाइम शहरी परिवहन',
      service8Desc:
        'गतिशीलता, स्थान और उपयोगकर्ता अनुभव पर ध्यान केंद्रित करते हुए शहरी परिवहन की रियल-टाइम निगरानी और विज़ुअलाइज़ेशन के लिए स्मार्ट समाधान।',
      
      cta: 'सभी सेवाएं देखें'
    },
    
    // Founder
    founder: {
      title: 'संस्थापक से मिलें',
      name: 'विलियम सार्टी जोस',
      role: 'संस्थापक और सॉफ्टवेयर इंजीनियर',
      bio: 'सूचना प्रौद्योगिकी में 10 से अधिक वर्षों के अनुभव के साथ, विलियम Java, React और कृत्रिम बुद्धिमत्ता के विशेषज्ञ हैं। उनके करियर में कंप्यूटर विज्ञान शिक्षक, वरिष्ठ डेवलपर और जटिल तकनीकी परियोजनाओं के नेता के रूप में काम शामिल है।',
      bio2: 'ठोस शैक्षणिक और व्यावसायिक अनुभव के साथ स्नातक, विलियम गहन तकनीकी ज्ञान को व्यावसायिक रणनीतिक दृष्टि के साथ जोड़ते हैं, ऐसे समाधान प्रदान करते हैं जो वास्तव में ग्राहकों के लिए अंतर बनाते हैं।',
      
      expertiseTitle: 'विशेषज्ञता के क्षेत्र',
      expertise1: 'Java और Spring Framework',
      expertise2: 'React और फ्रंटएंड विकास',
      expertise3: 'कृत्रिम बुद्धिमत्ता और मशीन लर्निंग',
      expertise4: 'सिस्टम आर्किटेक्चर',
      expertise5: 'परियोजना प्रबंधन',
      expertise6: 'शिक्षण और मार्गदर्शन',
      
      authorityTitle: 'पेशेवर प्राधिकरण',
      linkedin: 'पेशेवर LinkedIn',
      lattes: 'Lattes CV',
      github: 'GitHub रिपॉजिटरी',
      professionalCourse: 'व्यावसायिक पाठ्यक्रम',
      location: 'ब्रागा, पुर्तगाल'
    },
    
    // Contact
    contact: {
      title: 'आइए अपने व्यवसाय को बदलें?',
      subtitle: 'संपर्क करें और जानें कि हम आपकी कंपनी को नई ऊंचाइयों तक पहुंचने में कैसे मदद कर सकते हैं',
      
      formTitle: 'अपना संदेश भेजें',
      nameLabel: 'आपका नाम',
      namePlaceholder: 'अपना पूरा नाम दर्ज करें',
      emailLabel: 'आपका ईमेल',
      emailPlaceholder: 'aapka@email.com',
      phoneLabel: 'फोन (वैकल्पिक)',
      phonePlaceholder: '+91 00000 00000',
      messageLabel: 'संदेश',
      messagePlaceholder: 'हमें अपनी परियोजना के बारे में बताएं...',
      submitButton: 'संदेश भेजें',
      
      whatsappTitle: 'या व्हाट्सएप पर सीधे बात करें',
      whatsappButton: 'व्हाट्सएप खोलें',
      
      infoTitle: 'संपर्क जानकारी',
      phone: 'फोन',
      email: 'ईमेल',
      locationLabel: 'स्थान',
      phonesTitle: 'फ़ोन लाइनें',
      locationsTitle: 'स्थान',
      phoneBrazilLabel: 'ब्राज़ील',
      phonePortugalLabel: 'पुर्तगाल',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'साओ पाउलो, ब्राज़ील',
      locationPortugal: 'ब्रागा, पुर्तगाल'
    },
    
    // Footer
    footer: {
      tagline: 'विचारों को उत्कृष्ट डिजिटल समाधानों में बदलना',
      servicesTitle: 'सेवाएं',
      companyTitle: 'कंपनी',
      contactTitle: 'संपर्क',
      
      servicesList: {
        web: 'वेब विकास',
        ecommerce: 'ई-कॉमर्स',
        marketing: 'डिजिटल मार्केटिंग',
        automation: 'स्वचालन',
        mobile: 'मोबाइल ऐप्स'
      },
      
      companyList: {
        about: 'हमारे बारे में',
        methodology: 'पद्धति',
        founder: 'संस्थापक',
        contact: 'संपर्क'
      },
      
      copyright: '© 2025 WSJ डिजिटल सॉल्यूशंस। सर्वाधिकार सुरक्षित।',
      followTitle: 'WSJ को फॉलो करें',
      madeWith: 'के साथ बनाया',
      location: 'ब्रागा, पुर्तगाल में'
    }
  },

  ...siteLocales
};

export const languages = [
  { code: 'pt-BR', name: 'Português BR', flag: '🇧🇷' },
  { code: 'pt-PT', name: 'Português PT', flag: '🇵🇹' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
  { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' }
];
